import React, { useEffect, useState } from "react";
import axios from "axios";
import { Badge, Group } from "@mantine/core";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { ErrorView, PageTitle } from "@components/shared";
import { InstrumentItemsPanel } from "@components/ConceptualItem";
import entityIcon from "@util/entityIcon";
import entityColor from "@util/entityColor";

function statusColor(status) {
  if (status === 1) return "green";
  if (status === 2) return "gray";
  if (status === 3) return "red";
  return "gray";
}

export default function ConceptualItemDetail() {
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [item, setItem] = useState(null);
  const params = useParams();
  const conceptualRootId = params.id;
  const conceptualItemId = params.itemId;

  useEffect(() => {
    fetchData();
  }, [conceptualRootId, conceptualItemId]);

  function fetchData() {
    axios
      .get(
        `/conceptual-roots/${conceptualRootId}/conceptual-items/${conceptualItemId}/`
      )
      .then(({ data }) => {
        setItem(data.response[0]);
        setError(null);
      })
      .catch((err) => {
        setError(err);
        setItem(null);
      });
  }

  if (error) {
    return <ErrorView text={error} />;
  }

  if (!item) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <Group mb="lg">
        <PageTitle
          title={item.facet_formatted || item.label || item.facet}
          subtitle="Conceptual Item"
          icon={entityIcon.question()}
          iconColor={entityColor.role}
        />
        <Badge variant="light" color={statusColor(item.status)}>
          {item.status_formatted || t("status")}
        </Badge>
      </Group>
      <InstrumentItemsPanel
        conceptualRootId={conceptualRootId}
        conceptualItemId={conceptualItemId}
      />
    </div>
  );
}
